import {
  ThemeIconProps as MantineThemeIconProps,
  ThemeIcon as MantineThemeIcon,
} from '@mantine/core';

export type ThemeIconProps = MantineThemeIconProps;

export const ThemeIcon = MantineThemeIcon;

ThemeIcon.displayName = 'ThemeIcon';
